import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Payroll from "../../Components/Payroll";
import CustomerCare from "../../Components/CustomerCare";
import Pagination from "../../Components/Pagination";
import CasinoLeftPart from "./casinoLeft/CasinoLeftPart";
import Winners from "./Winners";
import CenterImageSlider from "../../Components/CenterImageSlider";
import CasinoCenter from "./casinoCenter/CasinoCenter";
import CasinoBestSlipDesktop from "./casinoRight/CasinoBestSlipDesktop";
import BestSlipMobile from "./bestSlipMobileCasinoPage/bestSlipMobile";
import MobileLeftPart from "./casinoLeft/MobileLeftPart";
import { useGetEuroVirtualGamesQuery } from "../../store/apis";
import {
  getAvailableDimensions,
  importGameImages,
  PROVIDERS,
  loadAllGameImages,
  topGamesData,
  importLivePragmaticGameImages,
} from "../../utils";
import BottomNavigation from "../../Components/BottonNavigation";

const Casino = () => {
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedDimension, setSelectedDimension] = useState("225-140");
  const [selectedGame, setSelectedGame] = useState("");
  const [games, setGames] = useState({});
  const [allProviderGames, setAllProviderGames] = useState({});
  const [dimensions, setDimensions] = useState([]);
  // Default category is "All" to load all games
  const [activeCategory, setActiveCategory] = useState("All");
  const [virtualGames, setVirtualGames] = useState([]);
  const [livePragmaticGames, setLivePragmaticGames] = useState([]);
  const [isLoadingAllGames, setIsLoadingAllGames] = useState(false);
  const { data, isLoading } = useGetEuroVirtualGamesQuery();

  useEffect(() => {
    if (data && data.data) {
      setVirtualGames(data.data.data);
    }
  }, [data]);
  useEffect(() => {
    const fetchLivePragmaticGames = async () => {
      const liveGames = await importLivePragmaticGameImages();
      setLivePragmaticGames(liveGames);
    };
    fetchLivePragmaticGames();
  }, []);

  const handleCategoryChange = (categoryName) => {
    setActiveCategory(categoryName);
  };

  // Effect for initial provider setup and loading all games
  useEffect(() => {
    // Set initial provider
    const initialProvider = Object.values(PROVIDERS)[0];
    setSelectedProvider(initialProvider);

    // Load all games from all providers
    const loadAllGames = async () => {
      setIsLoadingAllGames(true);
      try {
        const allGames = {};
        // Load games from each provider
        for (const provider of Object.values(PROVIDERS)) {
          const providerGames = await importGameImages(
            provider.folderName,
            selectedDimension
          );
          // Merge with all games
          Object.assign(allGames, providerGames);
        }
        setAllProviderGames(allGames);
      } catch (error) {
        console.error("Error loading all games:", error);
      } finally {
        setIsLoadingAllGames(false);
      }
    };

    loadAllGames();
  }, []);

  // Effect for loading dimensions when provider changes
  useEffect(() => {
    const loadDimensions = async () => {
      if (selectedProvider) {
        const availableDimensions = await getAvailableDimensions(
          selectedProvider.folderName
        );
        setDimensions(availableDimensions);

        // Set default dimension or keep current if available
        if (!availableDimensions.includes(selectedDimension)) {
          setSelectedDimension(availableDimensions[0]);
        }
      }
    };

    loadDimensions();
  }, [selectedProvider, selectedDimension]);

  // Effect for loading games when provider or dimension changes
  useEffect(() => {
    const loadGames = async () => {
      if (selectedProvider) {
        const gameImages = await importGameImages(
          selectedProvider.folderName,
          selectedDimension
        );
        setGames(gameImages);
      }
    };

    loadGames();
  }, [selectedProvider, selectedDimension]);

  const formatVirtualGames = () => {
    const formattedGames = {};
    virtualGames.forEach((game) => {
      formattedGames[game.game_uuid] = {
        imagePath: game.thumbnail,
        provider: "eurovirtual",
        gameName: game.game_name,
        isVirtual: true,
        currency: game.currency,
        minStake: JSON.parse(game.minimum_stake),
        maxStake: JSON.parse(game.maximum_stake),
        maxWin: JSON.parse(game.maximum_win),
        denominations: game.denomination,
      };
    });
    return formattedGames;
  };

  const handleGameClick = (alias) => {
    setSelectedGame(alias);
  };

  // Modified to handle the "All" category by returning games from all providers
  const getDisplayGames = () => {
    if (activeCategory === "Virtuals") {
      return formatVirtualGames();
    } else if (activeCategory === "All") {
      // For "All" category, show games from all providers
      const combinedGames = { ...allProviderGames };

      // Optionally include virtual games in "All" category
      if (virtualGames.length > 0) {
        const formattedVirtualGames = formatVirtualGames();
        Object.assign(combinedGames, formattedVirtualGames);
      }

      return combinedGames;
    } else if (activeCategory === "Top") {
      return topGamesData;
    } else if (activeCategory === "PragmaticLive") {
      return livePragmaticGames;
    }

    // For other categories or specific provider selection
    return games;
  };

  return (
    <>
      <div className="relative bg-darkGreen pb-[70px] s15:pb-[100px]">
        <div className="w-full max-w-[1760px] mx-auto">
          <div className="grid grid-cols-12 gap-5 md:gap-3 s18:gap-5">
            {/* center part */}
            <div className="col-span-12 md:col-span-12 s15:col-span-12">
              <div className="flex flex-col gap-[10px] ">
                <>
                  <CenterImageSlider />
                </>

                <div className="rounded-md shadow-inputshadow">
                  <>
                    <Winners />
                  </>
                  <>
                    <div className="bg-teal s15:p-5 md:rounded-md shadow-inputshadow min-h-screen">
                      <div className="max-w-[1760px] mx-auto">
                        <CasinoLeftPart
                          selectedProvider={selectedProvider}
                          setSelectedProvider={(provider) => {
                            setActiveCategory(provider ? provider.id : "All");
                            setSelectedProvider(provider);
                          }}
                          activeCategory={activeCategory}
                          onCategoryChange={handleCategoryChange}
                        />
                        <CasinoCenter
                          games={getDisplayGames()}
                          onGameClick={handleGameClick}
                          isVirtual={activeCategory === "Virtuals"}
                          isLoading={
                            isLoadingAllGames && activeCategory === "All"
                          }
                        />
                      </div>
                    </div>
                  </>
                  <BottomNavigation />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Casino;
